import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const DURATION = 350; // ms — fast enough not to feel slow

const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const rafRef = useRef(null);

  useEffect(() => {
    // If the URL has a hash anchor (#section), let the browser handle it.
    if (hash) return;

    // Already at the top — nothing to animate.
    const start = window.scrollY || window.pageYOffset || 0;
    if (start === 0) return;

    // Respect reduced-motion preference.
    const reduceMotion =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) {
      window.scrollTo(0, 0);
      return;
    }

    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    const startTime = performance.now();

    const tick = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / DURATION, 1);
      window.scrollTo(0, start * (1 - easeOutCubic(progress)));
      if (progress < 1) {
        rafRef.current = requestAnimationFrame(tick);
      }
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [pathname, hash]);

  return null;
};
